// LineMapper.js — turns a lyric line into placed bars + a step budget.
// Bars sit along a connected orthogonal path (see PathBuilder). Pure, no DOM.

import { STEP_SLACK } from "../config.js";
import { buildPath } from "./PathBuilder.js";

/**
 * @param {string[]} chars  characters of the active line, in reading order
 * @param {{cols:number, rows:number}} grid
 * @returns {{ items: Array, stepBudget: number, start: {col,row} }}
 */
export function mapLine(chars, grid) {
    const path = buildPath(chars.length, grid);

    const items = chars.map((char, order) => ({
        id: `${order}-${char}`,
        char,
        col: path[order].col,
        row: path[order].row,
        order,
        collected: false,
        missed: false,
    }));

    // Miku spawns on the first bar; she needs ~(count-1) steps to walk the
    // rest of the path, plus STEP_SLACK to recover from wrong turns.
    return {
        items,
        stepBudget: chars.length + STEP_SLACK,
        start: { col: path[0].col, row: path[0].row },
    };
}
